import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageSuccessComponent } from '../../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageFailComponent } from '../../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { DataService } from '../../../../../services/data.service';
import { Console } from '@angular/core/src/console';
import { Router } from '@angular/router';
import { TaxForm } from './../../../../../models/TaxForm';
import { TaxFormFile } from './../../../../../models/TaxFormFile';
import { VendorService } from './../../../../../services/vendor.service';

@Component({
  selector: 'app-1099-forms',
  templateUrl: './1099-forms.component.html',
  styleUrls: ['./1099-forms.component.scss']
})
export class Forms1099Component implements OnInit {
  showSuccessConfirmation = false;
  showFailConfirmation = false;
  public fileData: Uint8Array;
  showInvalidFileMessage = false;
  InvalidFileMessage: string;
  taxForm: TaxForm = new TaxForm();
  taxFromFile: TaxFormFile = new TaxFormFile();
  userInfo:any;
  private alive = true;
  reader: FileReader = new FileReader();
  inputVariable: any;
  constructor( private _router: Router,  private vendorSvc: VendorService,
    private spinner: NgxSpinnerService, private datasvc: DataService) { }

  ngOnInit() {
  }

  onSubmitClick() {
    // this.question = new Question();
    console.log('inside on submit');
  }

  wait2sec() {
    return new Promise(function(resolve, reject) {
      setTimeout(function() {
        resolve();
      }, 2000);
    });
  }

  resetFileInput() {
    this.inputVariable.nativeElement.value = "";
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
     this.fileData = new Uint8Array(this.reader.result);
    };
    /*this.reader.onprogress = function(data) {
      if (data.lengthComputable) {
        let progress = parseInt( ((data.loaded / data.total) * 100), 10 );
        console.log()
      }
    }*/
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
}

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  async handleFileInput(files: FileList) {
    console.log('first log');
    this.showInvalidFileMessage = false;
    if (files.length !== 1) {
      console.log('Only support upload 1 file');
      this.resetFileInput();
      return;
    }
    // File size limit, 11M
    if (files[0].size > 11534336) {
      this.InvalidFileMessage = "This file's size exceeds the limit";
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    console.log('Inside handle');
    console.log(files.length);
    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();
    console.log('After handle');
    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.InvalidFileMessage = "We don't support " + fileExt + " file";
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    this.spinner.show();
    this.readFile(files);
    await this.wait2sec();
    this.taxForm.FileName =   Date.now().toString() + fileExt;
    this.taxForm.AttachmentFilePath = this.taxFromFile.fileName;
    // this.questionFile.fileData = btoa(this.fileData.reduce((data, byte) => data  + String.fromCharCode(byte), ''));
    // this.taxFromFile.fileData = this.arrayBufferToBase64(this.fileData);
    this.taxForm.FileBytesBase64 = this.arrayBufferToBase64(this.fileData);
    this.taxForm.GPVID = this.datasvc.userDisplayInfo.GPVID;
    this.vendorSvc.updateVendorTaxForm(this.taxForm)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.spinner.hide();
        console.log(data);
      },
      err => {
        this.spinner.hide();
        this.taxForm.AttachmentFilePath = null;
        console.log(err);
      }
    );
  }
  goToVendor() {
    this._router.navigate(['/pages/vendor']);
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  closeConfirmation(event) {
    this.showSuccessConfirmation = false;
    this.showFailConfirmation = false;
    //this.question = new Question();
   //this.selectedCategoryId = '';
   //this.textAreaModel = '';
  }
  public ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/tax-forms/1099-forms/1099-forms.component.ts